// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__main-container__vdpzm {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  padding: 5px;
}
.index-module__icon-grid__pmFM8 {
  display: flex;
  flex-wrap: wrap;
  gap: 17px;
}
.index-module__icon__WmhcC {
  font-size: 23px;
  font-weight: bold;
  color: var(--app-primary-color);
  cursor: pointer;
  transition: color 0.3s ease-in-out;
}
.index-module__icon__WmhcC:hover {
  color: var(--app-primary-color);
}
.index-module__action-icon__np93p {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 23px;
  color: var(--app-primary-color);
  cursor: pointer;
}
.index-module__action-icon__np93p.index-module__disabled__zWkRC {
  opacity: 0.5;
  color: #595959;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CustomPopoverActions/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.main-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  padding: 5px;\n}\n.icon-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 17px;\n}\n.icon {\n  font-size: 23px;\n  font-weight: bold;\n  color: var(--app-primary-color);\n  cursor: pointer;\n  transition: color 0.3s ease-in-out;\n}\n.icon:hover {\n  color: var(--app-primary-color);\n}\n.action-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 23px;\n  color: var(--app-primary-color);\n  cursor: pointer;\n}\n.action-icon.disabled {\n  opacity: 0.5;\n  color: #595959;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-container": `index-module__main-container__vdpzm`,
	"icon-grid": `index-module__icon-grid__pmFM8`,
	"icon": `index-module__icon__WmhcC`,
	"action-icon": `index-module__action-icon__np93p`,
	"disabled": `index-module__disabled__zWkRC`
};
export default ___CSS_LOADER_EXPORT___;
